import { atom } from 'jotai'
import { timestampsAtom } from '../../store/timestamps.store'

export const tickAtom = atom(1)
export const isTickingAtom = atom(false)

let tickInterval: NodeJS.Timeout | null = null

export const tickControlAtom = atom(
  (get) => get(isTickingAtom),
  (get, set, shouldTick) => {
    const isTicking = get(isTickingAtom)

    if (shouldTick && !isTicking) {
      // Start ticking
      set(isTickingAtom, true)
      set(tickAtom, (prev) => prev + 1) // Initial tick
      set(timestampsAtom)

      tickInterval = setInterval(() => {
        set(tickAtom, (prev) => prev + 1)
        set(timestampsAtom)
      }, 300)
    } else if (!shouldTick && isTicking) {
      // Stop ticking
      set(isTickingAtom, false)
      // Reset tick value to avoid huge numbers
      set(tickAtom, 1)

      if (tickInterval) {
        clearInterval(tickInterval)
        tickInterval = null
      }
    }
  },
)
